var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1159_34409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9988 25.0012V46.4975C49.9988 48.4335 48.43 50.0023 46.494 50.0023H24.9977C24.9977 63.8103 36.1909 75.0035 49.9988 75.0035C63.8068 75.0035 75 63.8103 75 50.0023C75 36.1944 63.8068 25.0012 49.9988 25.0012Z",
    fill: "#63D577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5025 25.0012H49.9988C49.9988 11.1932 38.8056 0 25.0012 0C11.1967 0 0 11.1932 0 25.0012C0 38.8091 11.1932 50.0023 25.0012 50.0023V28.506C25.0012 26.57 26.57 25.0012 28.506 25.0012H28.5025Z",
    fill: "#AFFF54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9988 46.494V24.9977H28.5025C26.5665 24.9977 24.9977 26.5665 24.9977 28.5025V49.9988H46.494C48.43 49.9988 49.9988 48.43 49.9988 46.494Z",
    fill: "#FEF051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1159_34409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.9eb2da4e0997936b7f3b4bd29c4be1eb.svg";
export { ForwardRef as ReactComponent };